/*
 * @Author: your name
 * @Date: 2020-11-10 09:49:46
 * @LastEditTime: 2020-11-17 19:01:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/store/modules/mine.js
 */
import {
  getAllAddress,
  getUserInfo,
  updateUserInfo,
  findCertificationByPage,
  setDefault,
  removeCertification,
  addCertification,
  upload,
  // queryCardVoucherUserCount,
  getUserPhone,
  changePassword,
  changePhone,
  getUserAddress,
  addAddress,
  updateAddress,
  getAddressById,
  wechatBinding,
  queryCardVoucherUserPackage,
  queryCardVoucherUserByPage,
  queryCardVoucherUserRecordByPage,
  queryCardVoucherUserById,
  deleteAddress,
  getSimpleUserInfo
} from "@/api/mine";
const state = {
  addressData: [],
  getUserInfo: {
    avatarUrl: null,
    username: ""
  },
  findCertificationByPage: {
    pageNo: 0,
    rows: [],
    hasNextPage: false
  },
  // queryCardVoucherUserCount: 0,
  truePhone: "",
  getUserAddressList: {},
  getAddressById: {},
  queryCardVoucherUserPackage: {},
  queryCardVoucherUserByPage: {
    rows: []
  },
  queryCardVoucherUserRecordByPage: {
    rows: []
  },
  queryCardVoucherUserById: {},
  getSimpleUserInfo: {}
};

const mutations = {
  SET_ADDRESSDATA(state, data) {
    state.addressData = data;
  },
  SET_GETUSERINFO(state, data) {
    state.getUserInfo = data;
  },
  // SET_QUERYCARDVOUCHERUSERCOUNT(state, data) {
  //   state.queryCardVoucherUserCount = data;
  // },
  SET_FINDCERTIFICATIONBYPAGE(state, data) {
    if (data.pageNo === 0 || data.pageNo === 1) {
      state.findCertificationByPage = data;
    } else {
      const data1 = state.findCertificationByPage.rows;
      const data2 = data.rows;
      const rows = [...data1, ...data2];
      data.rows = rows;
      state.findCertificationByPage = data;
    }
  },
  SET_GETUSERADDRESSLIST(state, data) {
    if (data.pageNo === 0 || data.pageNo === 1) {
      state.getUserAddressList = data;
    } else {
      const data1 = state.getUserAddressList.rows;
      const data2 = data.rows;
      const rows = [...data1, ...data2];
      data.rows = rows;
      state.getUserAddressList = data;
    }
  },
  SET_DEFAULT() {},
  SET_REMOVEDEFAULT() {},
  SET_ADDEFAULT() {},
  SET_UPLOAD() {},
  SET_CHANGEPASSWORD() {},
  SET_CHANGEPHONE() {},
  SET_ADDADDRESS() {},
  SET_UPDATEADDRESS() {},
  SET_WECHATBINDING() {},
  SET_GETSINGLEADDRESS(state, data) {
    state.getAddressById = data;
  },
  SET_TRUEPHONE(state, data) {
    state.truePhone = data;
  },
  SET_GET_SIMPLE_USERINFO(state, data) {
    state.getSimpleUserInfo = data;
  },
  SET_QUERYCARDVOUCHERUSERPACKAGE(state, data) {
    // if (data.pageNo === 0 || data.pageNo === 1) {
    //   state.queryCardVoucherUserPackage = data;
    // } else {
    //   const data1 = state.queryCardVoucherUserPackage.rows;
    //   const data2 = data.rows;
    //   const rows = [...data1, ...data2];
    //   data.rows = rows;
    //   state.queryCardVoucherUserPackage = data;
    // }
    state.queryCardVoucherUserPackage = data;
  },
  SET_QUERYCARDVOUCHERUSERBYPAGE(state, data) {
    if (data.pageNo === 0 || data.pageNo === 1) {
      state.queryCardVoucherUserByPage = data;
    } else {
      const data1 = state.queryCardVoucherUserByPage.rows;
      const data2 = data.rows;
      const rows = [...data1, ...data2];
      data.rows = rows;
      state.queryCardVoucherUserByPage = data;
    }
  },
  SET_QUERYCARDVOUCHERUSERRECORDBYPAGE(state, data) {
    if (data.pageNo === 0 || data.pageNo === 1) {
      state.queryCardVoucherUserRecordByPage = data;
    } else {
      const data1 = state.queryCardVoucherUserRecordByPage.rows;
      const data2 = data.rows;
      const rows = [...data1, ...data2];
      data.rows = rows;
      state.queryCardVoucherUserRecordByPage = data;
    }
  },
  SET_QUERYCARDVOUCHERUSERBYID(state, data) {
    state.queryCardVoucherUserById = data;
  }
};

const actions = {
  // 地址下拉列表
  async getAllAddress({ commit }) {
    const response = await getAllAddress();
    // console.log("地址下拉数据", response);
    if (response.code === 1) {
      commit("SET_ADDRESSDATA", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  async deleteAddress({ commit }, { params }) {
    const response = await deleteAddress(params);
    // console.log("删除地址", response);
    if (response.code === 1) {
      commit("", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 获取用户地址列表
  async getUserAddress({ commit }, { params }) {
    const response = await getUserAddress(params);
    // console.log("用户地址列表", response);
    if (response.code === 1) {
      commit("SET_GETUSERADDRESSLIST", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 我的页面数据
  async getUserInfo({ commit }) {
    const response = await getUserInfo();
    // console.log("我的页面数据", response);
    if (response.code === 1) {
      commit("SET_GETUSERINFO", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 我的页面卡券数据
  // async queryCardVoucherUserCount({ commit }) {
  //   const response = await queryCardVoucherUserCount();
  //   // console.log("我的页面卡券数据", response);
  //   if (response.code === 1) {
  //     commit("SET_QUERYCARDVOUCHERUSERCOUNT", response.data);
  //     return Promise.resolve();
  //   } else return Promise.reject();
  // },
  // 修改个人信息
  async updateUserInfo({ commit }, { params }) {
    const response = await updateUserInfo(params);
    // console.log("我的页面数据", response);
    if (response.code === 1) {
      commit("SET_GETUSERINFO", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 实名认证列表
  async findCertificationByPage({ commit }, { params }) {
    const response = await findCertificationByPage(params);
    // console.log("实名认证列表", response);
    if (response.code === 1) {
      commit("SET_FINDCERTIFICATIONBYPAGE", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 实名认证列表
  async setDefault({ commit }, { params }) {
    const response = await setDefault(params);
    // console.log("设置默认实名认证", response);
    if (response.code === 1) {
      commit("SET_DEFAULT", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 删除实名认证
  async removeCertification({ commit }, { params }) {
    const response = await removeCertification(params);
    // console.log("删除实名认证", response);
    if (response.code === 1) {
      commit("SET_REMOVEDEFAULT", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 添加实名认证
  async addCertification({ commit }, { params }) {
    const response = await addCertification(params);
    // console.log("添加实名认证", response);
    if (response.code === 1) {
      commit("SET_ADDEFAULT", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 上传文件
  async upload({ commit }, { params }) {
    // console.log(params, "上传文件接口参数");
    const response = await upload(params);
    // console.log("上传文件", response);
    if (response.code === 1) {
      commit("SET_UPLOAD", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 获取真实的手机号
  async getUserPhone({ commit }) {
    const response = await getUserPhone();
    if (response.code === 1) {
      commit("SET_TRUEPHONE", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 获取真实的手机号
  async changePassword({ commit }, { params }) {
    const response = await changePassword(params);
    if (response.code === 1) {
      commit("SET_CHANGEPASSWORD", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 获取真实的手机号
  async changePhone({ commit }, { params }) {
    const response = await changePhone(params);
    if (response.code === 1) {
      commit("SET_CHANGEPHONE", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 新增收货地址
  async addAddress({ commit }, { params }) {
    const response = await addAddress(params);
    if (response.code === 1) {
      commit("SET_ADDADDRESS", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 修改收货地址
  async updateAddress({ commit }, { params }) {
    const response = await updateAddress(params);
    if (response.code === 1) {
      commit("SET_UPDATEADDRESS", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 获取单个收货地址
  async getAddressById({ commit }, { params }) {
    const response = await getAddressById(params);
    if (response.code === 1) {
      commit("SET_GETSINGLEADDRESS", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 绑定手机号
  async wechatBinding({ commit }, { params }) {
    const response = await wechatBinding(params);
    if (response.code === 1) {
      commit("SET_WECHATBINDING", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 卡包列表
  async queryCardVoucherUserPackage({ commit }) {
    const response = await queryCardVoucherUserPackage();
    if (response.code === 1) {
      commit("SET_QUERYCARDVOUCHERUSERPACKAGE", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 卡券列表
  async queryCardVoucherUserByPage({ commit }, { params }) {
    const response = await queryCardVoucherUserByPage(params);
    if (response.code === 1) {
      commit("SET_QUERYCARDVOUCHERUSERBYPAGE", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 卡券使用记录列表
  async queryCardVoucherUserRecordByPage({ commit }, { params }) {
    const response = await queryCardVoucherUserRecordByPage(params);
    if (response.code === 1) {
      commit("SET_QUERYCARDVOUCHERUSERRECORDBYPAGE", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 卡券详情
  async queryCardVoucherUserById({ commit }, { params }) {
    const response = await queryCardVoucherUserById(params);
    if (response.code === 1) {
      commit("SET_QUERYCARDVOUCHERUSERBYID", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  },
  // 分享获取用户信息
  async getSimpleUserInfo({ commit }) {
    const response = await getSimpleUserInfo();
    if (response.code === 1) {
      commit("SET_GET_SIMPLE_USERINFO", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject();
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
